import { axiosApi } from '@/config/http';
import type { ApiResponse } from '@/config/http/types';
import type { PartnerSegment } from '@/models/ProfileInterface';

export interface LiquidationTotals {
  in_process: number;
  payed: number;
  rejected: number;
}

export const getLiquidationMetrics = async (range?: {
  dateBegin?: string;
  dateEnd?: string;
}) => {
  const response = await axiosApi.get<ApiResponse<LiquidationTotals>>(
    '/v1/liquidation/totals',
    { params: { date_begin: range?.dateBegin, date_end: range?.dateEnd } },
  );
  return response.data.response;
};

export const getPartnerSegment = async () => {
  const response = await axiosApi.get<ApiResponse<{ segment: PartnerSegment }>>(
    '/v1/partners/segment',
  );
  return response.data.response.segment;
};

export default {
  getLiquidationMetrics,
  getPartnerSegment,
};
